import React from 'react';
import { Countdown } from './Countdown';
import { TrustBadges } from './TrustBadges';
import { FadeIn } from './FadeIn';
import { ChevronRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-6 overflow-hidden" data-id="element-79">
      {/* Background grid effect */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,107,26,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,107,26,0.3) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-80" />
      {/* Orange glow top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-hyrox-orange/10 rounded-full blur-[120px] pointer-events-none" data-id="element-81" />

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-82">
        <FadeIn data-id="element-83">
          <span className="inline-block bg-hyrox-surface border border-hyrox-muted text-gray-300 text-[10px] sm:text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4" data-id="element-84">
            Stock Digital™ — Formación para Coaches
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-85">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black mb-3 leading-[0.95] tracking-tight uppercase text-balance text-hyrox-orange drop-shadow-[0_0_30px_rgba(255,107,26,0.4)]" data-id="element-86">
            Resolvé todo tu año de clases de HYROX
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-87">
          <p className="text-sm sm:text-lg text-gray-300 font-medium mb-6 max-w-2xl mx-auto leading-snug text-balance" data-id="element-88">
            Si sos coach de HYROX y todavía improvisás sesiones, no medís el
            progreso de tus alumnos y no sabés cómo justificar subir tus
            precios, esto es exactamente para vos.
          </p>
        </FadeIn>

        <FadeIn delay={0.22} data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/25zysCr4qJYaAcgE3MZP35/Hyrox.png" alt="Mega Pack HYROX para Coaches — 6 tomos y 5 bonos de alto rendimiento" className="w-auto max-h-[28vh] sm:max-h-[34vh] mx-auto mb-6 object-contain drop-shadow-[0_20px_50px_rgba(255,107,26,0.2)]" data-id="element-90" />
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col items-center gap-3 sm:gap-4 w-full" data-id="element-91">
          <Countdown data-id="element-92" />

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-hyrox-orange hover:bg-hyrox-orangeHover text-white font-display rounded-xl px-8 sm:px-10 py-3 sm:py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_rgba(255,107,26,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hyrox-orange" data-id="element-93">
            <span className="flex items-center gap-2 font-black text-lg sm:text-2xl leading-none" data-id="element-94">
              QUIERO EL PACK AHORA
              <ChevronRightIcon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={3} data-id="element-95" />
            </span>
            <span className="font-bold text-sm sm:text-base text-white/80 mt-1" data-id="element-96">
              Precio de lanzamiento — $16.990
            </span>
          </button>

          <TrustBadges data-id="element-97" />
        </FadeIn>
      </div>
    </section>;
}